(() => {
  const videos = document.querySelectorAll('video[data-mdf-autoplay="true"]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!videos.length || reducedMotion.matches) return;
  const visibleVideos = new Set();
  const play = video => {
    if (!document.hidden) video.play().catch(() => {});
  };
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visibleVideos.add(entry.target);
        play(entry.target);
      } else {
        visibleVideos.delete(entry.target);
        entry.target.pause();
      }
    });
  }, { rootMargin: '120px 0px' });
  videos.forEach(video => observer.observe(video));
  document.addEventListener('visibilitychange', () => {
    visibleVideos.forEach(video => document.hidden ? video.pause() : play(video));
  });
})();
